import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// import RiExchangeFill from "../assets/svg/ProfileIcon";
import Whatsapp from "../assets/images/icons/whatsapp.png";
import Telegram from "../assets/images/icons/telegram.png";
import Facebook from "../assets/images/icons/facebook.png";
import Instagram from "../assets/images/icons/instagram.png";

import RNG from "../assets/images/providers/RNGCertified.webp";
import Gambling from "../assets/images/providers/GamblingCommission.webp";
import ResponsibleG from "../assets/images/providers/ResponsibleGamingFounding.webp";
import Gamble18 from "../assets/images/providers/18+gambleresponsibly.webp";
import PaymentMod from "../assets/images/providers/payment-option.webp";
import Betfair from "../assets/images/providers/betfair.webp";

import UPIImg from "../assets/images/providers/upi.svg";
import VisaMasterCardImg from "../assets/images/providers/visa-master.svg";
import VisaMasterCardImg2 from "../assets/images/providers/visa-master2.svg";
import PaytmImg from "../assets/images/providers/paytm.svg";
import NetBankingImg from "../assets/images/providers/net-banking.svg";

import BitcoinImg from "../assets/images/providers/crypto/Bitcoin.webp";
import EthereumImg from "../assets/images/providers/crypto/Ethereum.webp";
import TetherImg from "../assets/images/providers/crypto/Tether.webp";
import DaiCoinImg from "../assets/images/providers/crypto/DaiCoin.webp";
import DogecoinImg from "../assets/images/providers/crypto/Dogecoin.webp";
import LitecoinImg from "../assets/images/providers/crypto/Litecoin.webp";
import { FaSpinner } from "react-icons/fa";

import HomeIconHover from "../assets/images/games-icon/new/home-icon-silhouette.png";
import ExchangeHover from "../assets/images/games-icon/new/cricket.png";
import SportsIconHover from "../assets/images/games-icon/new/football.png";
import EzugiIconHover from "../assets/images/games-icon/new/lottery.png";
import CashierIconHover from "../assets/images/games-icon/new/money.png";

import BrandHeading from "../assets/images/icons/bird.webp";

const footerPages = [
  "home",
  "sportsbook",
  "casino/evolution",
  "casino/ezugi",
  "deposit",
  "exchange",
  "betby",
  "atlas-lobby",
  "/exchange/Inplay",
  "/sports/AGSE"
];

const Footer = () => {
  const { appDetails } = useSelector((state) => state.app);
  const [activePage, setActivePage] = useState("");
  const location = useLocation();

  useEffect(() => {
    const matchedValue = footerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={4} className="text-center">
            <div className="foot-logo">
              <a href="/">
                {appDetails?.LOGO_URL ? (
                  <img src={appDetails?.LOGO_URL} alt="Logo" />
                ) : (
                  <FaSpinner />
                )}
              </a>
              <div className="brandheading">
                <img src={BrandHeading} alt="BrandHeading" />
                <div className="BrandName">
                  <h2>Our Partner</h2>
                  <h1>Equirise</h1>
                </div>
              </div>
            </div>
            <div className="about-site">
              <p>{appDetails?.FOOTER_TEXT || ""}</p>
            </div>
            <div className="social-icons">
              <ul>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "javascript:void(0)"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <img src={Whatsapp} alt="Whatsapp Icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.TELEGRAM != ""
                        ? appDetails?.TELEGRAM
                        : "javascript:void(0)"
                    }
                    target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Telegram} alt="Telegram Icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.FACEBOOK != ""
                        ? appDetails?.FACEBOOK
                        : "javascript:void(0)"
                    }
                    target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                  >
                    <img src={Facebook} alt="Facebook Icon" />
                  </a>
                </li>
                <li>
                  <a
                    className="panel"
                    href={
                      appDetails?.INSTATGRAM != ""
                        ? appDetails?.INSTATGRAM
                        : "javascript:void(0)"
                    }
                    target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                  >
                    <img src={Instagram} alt="Instagram Icon" />
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4} className="quick-linksSection">
            <div className="quick-links">
              <h1>Quick Links</h1>
              <ul>
                <li>
                  <a href="/contactus">Contact Us</a>
                </li>

                <li>
                  <a href="/privacypolicy ">Privacy Policy</a>
                </li>
                <li>
                  <a href="/responsiblegames">Responsible Gaming</a>
                </li>
                <li>
                  <a href="/fairplay">Fair Play</a>
                </li>
                <li>
                  <a href="/gamesrule">Games Rules</a>
                </li>
                <li>
                  <a href="/terms">Terms and Conditions</a>
                </li>
              </ul>
            </div>
          </Col>

          <Col xs={12} lg={4} className="d-flex d-md-block flex-wrap">
            <div className="payment-methods">
              <h1>Payment Methods</h1>
              <ul>
                <li>
                  <img src={UPIImg} alt="upi" />
                </li>
                <li className="visa-mstr">
                  <img
                    src={VisaMasterCardImg}
                    alt="visa/master casrd"
                    className="d-none d-md-block"
                  />
                  <img
                    src={VisaMasterCardImg2}
                    alt="visa/master casrd"
                    className="d-md-none"
                  />
                </li>
                <li>
                  <img src={PaytmImg} alt="paytm" />
                </li>
                <li>
                  <img src={NetBankingImg} alt="net banking" />
                </li>
              </ul>
              <ul className="crypto-icons">
                <li>
                  <img src={BitcoinImg} alt="bitcoin" />
                </li>
                <li>
                  <img src={EthereumImg} alt="ethereum" />
                </li>
                <li>
                  <img src={TetherImg} alt="tether" />
                </li>
                <li>
                  <img src={DaiCoinImg} alt="daiCoin" />
                </li>
                <li>
                  <img src={DogecoinImg} alt="dogecoin" />
                </li>
                <li>
                  <img src={LitecoinImg} alt="litecoin" />
                </li>
              </ul>
              {/* <p style={{ color: "#848484" }}>
                  Accept, process &amp; disburse digital payments for your
                  business.
                </p> */}
            </div>
            <div className="responsible-gaming">
              <h1>Responsible Gaming</h1>
              <ul>
                <li>
                  <img
                    src={RNG}
                    alt="RNG Certified"
                    style={{ maxWidth: "90px" }}
                    height={44}
                  />
                </li>
                <li>
                  <img
                    src={Gambling}
                    alt="Gambling Commission"
                    style={{ maxWidth: "80px" }}
                    height={22}
                  />
                </li>
                <li>
                  <img
                    src={ResponsibleG}
                    alt="Responsible Gaming"
                    style={{ maxWidth: "120px" }}
                    height={35}
                  />
                </li>
                <li>
                  <img
                    src={Gamble18}
                    loading="lazy"
                    alt="Gamble Responsible"
                    style={{ maxWidth: "120px" }}
                    height={32}
                  />
                </li>
              </ul>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs="12" className="text-center">
            <p className="mt-4 mb-0">
              &copy; 2026 Annawins777. All rights reserved.
            </p>
          </Col>
        </Row>

        <div className="helpline d-none">
          <a
            className="panel"
            href={
              appDetails?.WHATS_APP_URL != ""
                ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                : "javascript:void(0)"
            }
            target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
          >
            <img src={Whatsapp} /> Whatsapp <p>{appDetails?.WHATS_APP_URL}</p>
          </a>
          <div className="facebook-footer">
            <a
              className="panel"
              href={
                appDetails?.TELEGRAM != ""
                  ? appDetails?.TELEGRAM
                  : "javascript:void(0)"
              }
              target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
            >
              <img src={Telegram} alt="telegram" />
            </a>
            <a
              className="panel social-icon watsapp"
              href={
                appDetails?.FACEBOOK != ""
                  ? appDetails?.FACEBOOK
                  : "javascript:void(0)"
              }
              target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
            >
              <img src={Facebook} />
            </a>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-2 d-none">
          <p style={{ color: "rgb(204, 204, 204)" }}>
            Accept, process &amp; disburse digital payments for your business.
          </p>
        </div>

        <div className="d-flex justify-content-center mt-3 mb-3 d-none">
          <img
            src={Betfair}
            loading="lazy"
            className="mb-3 betfair"
            alt="Betfair Logo"
          />
        </div>

        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 d-md-none d-block">
          <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
            <li>
              <a
                className={activePage === "/exchange/Inplay" ? "active" : ""}
                href="/exchange/Inplay"
              >
                {/* <SportsIcon /> */}
                <img src={ExchangeHover} className="hover" />

                <span>Exchange</span>
              </a>
            </li>
            {/* <li>
              <a href="/exchange">
                <img src={Exchange} alt="Exchange Icon" />
                <span>Exchange</span>
              </a>
            </li> */}
            <li>
              <a
                className={activePage === "/sports/AGSE" ? "active" : ""}
                href="/sports/AGSE"
              >
                {/* <SportsIcon /> */}
                <img src={SportsIconHover} className="hover" />

                <span>Exchange 2</span>
              </a>
            </li>
            <li>
              <a className={activePage === "home" ? "active" : ""} href="/home">
                {/* <HomeIcon /> */}
                <img src={HomeIconHover} className="hover" />

                <span>Home</span>
              </a>
            </li>
            <li>
              <a href="/home">
                {/* <GamesIcon /> */}
                <img src={EzugiIconHover} className="hover" />

                <span>Casino</span>
              </a>
            </li>
            <li>
              <a
                className={activePage === "deposit" ? "active" : ""}
                href="/gatewaylist"
              >
                {/* <CashierIcon /> */}
                <img src={CashierIconHover} className="hover" />

                <span>Deposit</span>
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
